module.exports = __webpack_public_path__ + "static/media/guia-da-alma.6dcf7bc7.svg";